var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPayment3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 24,
    viewBox: "0 0 34 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H30C32.2091 0 34 1.79086 34 4V20C34 22.2091 32.2091 24 30 24H4C1.79086 24 0 22.2091 0 20V4Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.179 16.8288C15.9949 17.8268 14.459 18.4293 12.7807 18.4293C9.03582 18.4293 6 15.4296 6 11.7293C6 8.02899 9.03582 5.0293 12.7807 5.0293C14.459 5.0293 15.9949 5.63179 17.179 6.62984C18.363 5.63179 19.8989 5.0293 21.5773 5.0293C25.3221 5.0293 28.358 8.02899 28.358 11.7293C28.358 15.4296 25.3221 18.4293 21.5773 18.4293C19.8989 18.4293 18.363 17.8268 17.179 16.8288Z",
    fill: "#ED0006"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1797 16.8288C18.6376 15.5999 19.5621 13.7713 19.5621 11.7293C19.5621 9.68734 18.6376 7.85874 17.1797 6.62984C18.3637 5.63179 19.8996 5.0293 21.578 5.0293C25.3228 5.0293 28.3587 8.02899 28.3587 11.7293C28.3587 15.4296 25.3228 18.4293 21.578 18.4293C19.8996 18.4293 18.3637 17.8268 17.1797 16.8288Z",
    fill: "#F9A000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1793 16.8278C18.6372 15.5989 19.5616 13.7703 19.5616 11.7283C19.5616 9.68638 18.6372 7.85779 17.1793 6.62888C15.7213 7.85779 14.7969 9.68638 14.7969 11.7283C14.7969 13.7703 15.7213 15.5989 17.1793 16.8278Z",
    fill: "#FF5E00"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayment3);
export default __webpack_public_path__ + "static/media/payment3.ca76a7317de2fca137fb6f8b2d077953.svg";
export { ForwardRef as ReactComponent };